export default {
    namespaced: true,
    state: {
        menu: false,
    },
    getters: {
        menu(state) {
            return state.menu
        }
    },
    mutations:{
        CHANGE_MENU_STATE(state, val){
            state.menu = val
        },
        TOGGLE_MENU(state){
            state.menu = !state.menu;
        }
    },
    actions:{
        openMenu(context){
            context.commit('CHANGE_MENU_STATE', true)
        },
        closeMenu(context) {
            context.commit('CHANGE_MENU_STATE', false)
        },
        toggleMenu(context) {
            context.commit('TOGGLE_MENU')
        }
    },
}
